import XQAvatar from "./XQAvatar.vue";
export default XQAvatar